import { createFeature, createReducer, on } from "@ngrx/store";
import { AddOrganizationActions } from "../../actions/add-organization/add-organization.actions";
import { OrganizationEMRDetailsActions } from "@store/actions/organization-emr-details/organization-emr-details.actions";
import { OrganizationEMR } from "@models/organizationEMR.model";

export const organizationEMRDetailsFeatureKey = "organizationEMRDetails";

export interface State {
  organizationId: string;
  isACO: number;
  emrList: OrganizationEMR[];
}

export const initialState: State = {
  organizationId: "",
  isACO: 0,
  emrList: [],
};

export const reducer = createReducer(
  initialState,

  on(AddOrganizationActions.getOrganizationDetailsSuccess, (state, action) => ({
    ...state,
    organizationId: action.details.organizationEMRs?.[0]?.organizationID ?? "",
    isACO: action.details.isMemberOfACO ?? 0,
    emrList: action.details.organizationEMRs ?? [],
  })),

  on(OrganizationEMRDetailsActions.isACOChanged, (state, action) => ({
    ...state,
    isACO: action.value,
  })),

  on(OrganizationEMRDetailsActions.addOrganizationEMRSuccess, (state, action) => ({
    ...state,
    emrList: [...state.emrList, action.data],
  })),
);

export const organizationEMRDetailsFeature = createFeature({
  name: organizationEMRDetailsFeatureKey,
  reducer,
});
